export default __webpack_public_path__ + "static/countdown_siri_3-169dcd82518a414d7ccf532e49160ea9.png";